import { createSelector } from '@reduxjs/toolkit';
import { SERVER_REQUEST_STATUS } from 'src/enums';

import { RootState } from '../../store';

const selectDocumentsState = (state: RootState) => state.documents;

const selectDocumentsData = createSelector(
  selectDocumentsState,
  (documents) => documents.data
);

const selectDocumentsLoader = createSelector(
  selectDocumentsState,
  (documents) => documents.status === SERVER_REQUEST_STATUS.PENDING
);

const selectDocumentsError = createSelector(
  selectDocumentsState,
  (documents) => documents.error
);

export default {
  selectDocumentsState,
  selectDocumentsData,
  selectDocumentsLoader,
  selectDocumentsError
};
